import React, { useEffect, useState, useCallback } from 'react';
import ContentBlock from './ContentTable';
import { getVoicesList } from '../../helpers/API/content/voices';
import { appLanguages } from '../../common/languages';

const Content = () => {
  const [voices, setVoices] = useState({});
  const [isLoading, setIsLoading] = useState({});

  const fetchVoices = useCallback(async (lang) => {
    setIsLoading(prev => ({ ...prev, [lang]: true }));
    const data = await getVoicesList(lang);
    setVoices(prev => ({ ...prev, [lang]: data }));
    setIsLoading(prev => ({ ...prev, [lang]: false }));
  }, []);

  useEffect(() => {
    appLanguages.forEach(lang => {
      fetchVoices(lang);
    });
  }, [fetchVoices]);

  return (
    <div className="page-content" style={{ marginTop: 105 }}>
      <div className="flex-row">
        <ContentBlock voices={voices} />
      </div>
    </div>
  );
};

export default Content;
